import React from 'react';
import classnames from 'classnames';
import QRCode from 'qrcode.react';
import _ from 'lodash';
import Button from 'app/components/general/Button';
import PaymentBadge from 'app/components/general/PaymentBadge';
import SelectInput from 'app/components/general/SelectInput';
import eventStatusTypes from 'app/utils/static/eventStatusTypes';

interface ITeamContainerProps {
  fixtureMatchDashboardId: string;
  containerLabel: string;
  groupName: string;
  groupChecked: boolean;
  loading: boolean;
  groupPaymentUrl: any;
  groupPaymentText: any;
  subscriptionPaymentId: any;
  paymentEventId: any;
  updateSubscriptionPayment: any;
  updatePaymentEvent: any;
  handleSidebarClose: any;
  getPaymentEvent: any;
  paymentData: any;
}

interface ITeamContainerState {
  showQRCode: boolean;
  loadingEftpos: boolean;
  loadingCash: boolean;
  loadingOtherStatus: boolean;
  loadingUndo: boolean;
  loadingPrepaid: boolean;
  loadingCancelled: boolean;
  loadingNoShow: boolean;
  otherStatus: any;
}
export default class TeamContainer extends React.PureComponent<
  ITeamContainerProps,
  ITeamContainerState
> {
  static defaultProps: ITeamContainerProps = {
    paymentData: undefined,
    fixtureMatchDashboardId: undefined,
    containerLabel: 'Team',
    groupName: undefined,
    groupChecked: undefined,
    groupPaymentText: undefined,
    groupPaymentUrl: undefined,
    subscriptionPaymentId: undefined,
    paymentEventId: undefined,
    updateSubscriptionPayment: undefined,
    updatePaymentEvent: undefined,
    handleSidebarClose: undefined,
    loading: false,
    getPaymentEvent: undefined,
  };

  state: ITeamContainerState = {
    showQRCode: false,
    loadingEftpos: false,
    loadingCash: false,
    loadingOtherStatus: false,
    loadingPrepaid: false,
    loadingUndo: false,
    otherStatus: undefined,
  };

  static getDerivedStateFromProps(props, state) {
    if (!props.loading) {
      return {
        loadingCash: false,
        loadingOtherStatus: false,
        loadingEftpos: false,
        loadingUndo: false,
      };
    }
    return null;
  }

  handleStatusChange = (id, status, paymentEventId): void => {
    if (status !== null) {
      const payload = {
        id,
        paymentStatus: undefined,
        adminStatus: undefined,
      };

      if (status === 'paid-cash') {
        this.setState({ loadingCash: true });
        payload.paymentStatus = status;
      }
      if (status === 'paid-eftpos') {
        this.setState({ loadingEftpos: true });
        payload.paymentStatus = status;
      }
      if (status === 'paid-prepaid') {
        this.setState({ loadingPrepaid: true });
        payload.paymentStatus = status;
      }
      if (status === 'pending') {
        this.setState({ loadingUndo: true });
        payload.paymentStatus = status;
      }
      if (status === 'cancelled') {
        this.setState({ loadingOtherStatus: true, otherStatus: status });
        payload.adminStatus = status;
      }
      if (status === 'no-show') {
        this.setState({ loadingOtherStatus: true, otherStatus: status });
        payload.adminStatus = status;
      }
      if (status === 'undo-admin') {
        this.setState({ loadingOtherStatus: true, otherStatus: status });
        payload.adminStatus = null;
      }

      this.props.updateSubscriptionPayment(
        payload,
        this.props.fixtureMatchDashboardId,
        paymentEventId,
      );

      this.props.handleSidebarClose();
    }
  };

  toggleQRCode = () => {
    this.setState({ showQRCode: !this.state.showQRCode });
  };

  renderUnpaid = (): React.ReactNode => {
    const qrCodeText = this.state.showQRCode ? 'Hide QR Code' : 'Show QR Code';
    return (
      <div>
        <div
          className={classnames({
            'card event-sidebar-row-container': true,
            'border-green': this.props.groupChecked,
          })}
        >
          <div className="event-sidebar-row">
            <div className="event-sidebar-row-text">
              {this.props.groupName}
              <PaymentBadge
                className="event-card-badge ml-auto"
                paymentText={this.props.groupPaymentText}
              />
            </div>
          </div>
          <div className="w-100">
            <div className="row mx-0">
              <div className="col px-2 no-left-padding">
                <Button
                  className="btn-standard btn-2 btn-blue w-100"
                  isLoading={this.props.loading && this.state.loadingEftpos}
                  loadingColor="grey"
                  type="submit"
                  onClick={() => this.handleStatusChange(
                    this.props.subscriptionPaymentId,
                    'paid-eftpos',
                    this.props.paymentEventId,
                  )}
                >
                  Paid EFTPOS
                </Button>
              </div>
              <div className="col px-2 no-right-padding">
                <Button
                  className="btn-standard btn-2 btn-orange w-100"
                  isLoading={this.props.loading && this.state.loadingCash}
                  loadingColor="grey"
                  type="submit"
                  onClick={() => this.handleStatusChange(
                    this.props.subscriptionPaymentId,
                    'paid-cash',
                    this.props.paymentEventId,
                  )}
                >
                  Paid Cash
                </Button>
              </div>
            </div>
            <div className="row mx-0">
              <div className="col px-2 no-left-padding">
                <Button
                  className="btn-standard btn-2 btn-yellow w-100"
                  isLoading={this.props.loading && this.state.loadingPrepaid}
                  loadingColor="grey"
                  type="submit"
                  onClick={() => this.handleStatusChange(
                    this.props.subscriptionPaymentId,
                    'paid-prepaid',
                    this.props.paymentEventId,
                  )}
                >
                  Paid Pre-paid
                </Button>
              </div>
              <div className="col px-2 no-right-padding">
                <Button
                  className="btn-standard btn-2 btn-black w-100"
                  isLoading={this.props.loading && this.state.loadingNoShow}
                  loadingColor="grey"
                  type="submit"
                  onClick={() => this.handleStatusChange(
                    this.props.subscriptionPaymentId,
                    'no-show',
                    this.props.paymentEventId,
                  )}
                >
                  No-show
                </Button>
              </div>
            </div>
            <div className="row mx-0">
              <div className="col px-2 no-left-padding">
                {this.state.showQRCode
                  && this.props.groupPaymentUrl !== undefined && (
                  <QRCode
                    value={this.props.groupPaymentUrl}
                    className="team-qr-code"
                  />
                )}
                <Button
                  className="btn-standard btn-1 w-100"
                  isLoading={false}
                  noLoading
                  type="submit"
                  onClick={this.toggleQRCode}
                >
                  {qrCodeText}
                </Button>
              </div>
              <div className="col px-2 no-right-padding" />
            </div>
          </div>
          {/* {this.renderNotes()} */}
          {/* <div className="w-100 with-margin-top-10">
            <SelectInput
              name="other-payment-method"
              className="large-bold"
              isLoading={this.props.loading && this.state.loadingOtherStatus}
              placeholder="Other..."
              value={this.state.otherStatus}
              onChange={(e) => this.handleOtherStatusChange(
                this.props.subscriptionPaymentId,
                this.props.paymentEventId,
                e,
              )}
              options={eventStatusTypes}
            />
          </div> */}
        </div>
      </div>
    );
  };

  renderPaidOther = (): React.ReactNode => (
    <div>
      <div
        className={classnames({
          'card event-sidebar-row-container': true,
          'card-blue': this.props.groupPaymentText === 'Eftpos',
          'card-yellow': this.props.groupPaymentText === 'Pre-paid',
          'card-orange': this.props.groupPaymentText === 'Cash',
          'card-black': this.props.groupPaymentText === 'No-show',
        })}
      >
        <div className="event-sidebar-row">
          <div className="event-sidebar-row-text">
            {this.props.groupName}
            <PaymentBadge
              className="event-card-badge ml-auto"
              paymentText={this.props.groupPaymentText}
            />
          </div>
        </div>

        <Button
          className="btn-standard btn-2 w-100"
          isLoading={this.props.loading && this.state.loadingUndo}
          loadingColor="grey"
          confirmButton
          type="submit"
          onClick={() => this.handleStatusChange(
            this.props.subscriptionPaymentId,
            'pending',
            this.props.paymentEventId,
          )}
        >
          Undo Payment
        </Button>
        {/* {this.renderNotes()} */}
      </div>
    </div>
  );

  renderVariableMetadata = (metadata): React.ReactNode => _.map(metadata.lineItems, (object) => (
    <div className="row w-100 no-gutters" key={object.code}>
      <div className="col text-left">{object.description}</div>
      <div className="col text-right text-weight-medium-bold text-capitalize">
        {object.quantity}
      </div>
    </div>
  ));

  renderPaidTeammo = (): React.ReactNode => (
    <div>
      <div
        className={classnames({
          'card event-sidebar-row-container': true,
          'border-green': this.props.groupChecked,
        })}
      >
        <div className="event-sidebar-row">
          <div className="event-sidebar-row-text">
            {this.props.groupName}
            <PaymentBadge
              className="event-card-badge ml-auto"
              paymentText={this.props.groupPaymentText}
            />
          </div>
        </div>
        {this.props.paymentData.paymentType === 'event-variable'
          && !_.isEmpty(this.props.paymentData.metadata) && (
          <div className="w-100">
            <div className="divider no-margin-side w-100" />
            {this.renderVariableMetadata(this.props.paymentData.metadata)}
          </div>
        )}
        <div className="divider no-margin-side w-100" />
        <div className="row w-100 no-gutters">
          <div className="col text-left">Amount Paid</div>
          <div className="col text-right text-weight-medium-bold">
            {this.props.paymentData.amount}
          </div>
        </div>
        <div className="row margin-top-5 w-100 no-gutters">
          <div className="col text-left">Receipt Reference</div>
          <div className="col text-right text-weight-medium-bold">
            {this.props.paymentData.receiptReference}
          </div>
        </div>
        <div className="row margin-top-5 w-100 no-gutters">
          <div className="col text-left">Date Paid</div>
          <div className="col text-right text-weight-medium-bold">
            {this.props.paymentData.datePaid}
          </div>
        </div>
        {/* {this.renderNotes()} */}
      </div>
    </div>
  );

  renderForfeit = (): React.ReactNode => (
    <div>
      <div className="card event-sidebar-row-container card-black">
        <div className="event-sidebar-row">
          <div className="event-sidebar-row-text">
            {this.props.groupName}
            <PaymentBadge
              className="event-card-badge ml-auto"
              paymentText={this.props.groupPaymentText}
            />
          </div>
        </div>
        <div className="event-sidebar-row margin-top-10">
          <div className="w-100 text-right text-weight-medium-bold">
            Paid
            {' '}
            {this.props.paymentData.forfeitAmount}
          </div>
        </div>
        {/* {this.renderNotes()} */}
      </div>
    </div>
  );

  renderNoShow = (): React.ReactNode => (
    <div>
      <div className="card event-sidebar-row-container card-black">
        <div className="event-sidebar-row">
          <div className="event-sidebar-row-text">
            {this.props.groupName}
            <PaymentBadge
              className="event-card-badge ml-auto"
              paymentText={this.props.groupPaymentText}
            />
          </div>
        </div>

        <Button
          className="btn-standard btn-2 w-100"
          isLoading={this.props.loading && this.state.loadingUndo}
          loadingColor="grey"
          type="submit"
          onClick={() => this.handleStatusChange(
            this.props.subscriptionPaymentId,
            'undo-admin',
            this.props.paymentEventId,
          )}
        >
          Undo
        </Button>
        {/* {this.renderNotes()} */}
      </div>
    </div>
  );

  renderCancelled = (): React.ReactNode => (
    <div>
      <div className="card event-sidebar-row-container card-black">
        <div className="event-sidebar-row">
          <div className="event-sidebar-row-text">
            {this.props.groupName}
            <PaymentBadge
              className="event-card-badge ml-auto"
              paymentText={this.props.groupPaymentText}
            />
          </div>
        </div>

        <Button
          className="btn-standard btn-2 w-100"
          isLoading={this.props.loading && this.state.loadingUndo}
          loadingColor="grey"
          type="submit"
          onClick={() => this.handleStatusChange(
            this.props.subscriptionPaymentId,
            'undo-admin',
            this.props.paymentEventId,
          )}
        >
          Undo
        </Button>
        {/* {this.renderNotes()} */}
      </div>
    </div>
  );

  renderNotes = (): React.ReactNode => (
    <div className="w-100">
      <div className="divider no-margin-side w-100" />
      <div className="row w-100 no-gutters">
        <div className="col text-left text-weight-medium-bold">Notes</div>
      </div>

      {/* {_.map(metadata.lineItems, (object) => (
        <div className="row w-100 no-gutters" key={object.code}>
          <div className="col text-left">{object.description}</div>
          <div className="col text-right text-weight-medium-bold">
            {object.quantity}
          </div>
        </div>
      ))} */}
    </div>
  )

  render(): React.ReactNode {
    let child = null;
    if (this.props.groupPaymentText === 'Unpaid') {
      child = this.renderUnpaid();
    }
    if (this.props.groupPaymentText === 'Teammo') {
      child = this.renderPaidTeammo();
    }
    if (
      this.props.groupPaymentText === 'Cancelled'
    ) {
      child = this.renderCancelled();
    }
    if (
      this.props.groupPaymentText === 'Forfeit'
    ) {
      child = this.renderForfeit();
    }
    if (this.props.groupPaymentText === 'No-show') {
      child = this.renderNoShow();
    }
    if (
      this.props.groupPaymentText === 'Eftpos'
      || this.props.groupPaymentText === 'Cash'
      || this.props.groupPaymentText === 'Pre-paid'
    ) {
      child = this.renderPaidOther();
    }
    if (child === null) {
      return null;
    }

    return (
      <div>
        {child}

      </div>
    );
  }
}
